<div class="search-hierarchic-bread-crumbs-wrapper">
  @for (breadcrumb of searchContainer.breadcrumbs; track $index) {
    <ng-container>
      @if (finishedLoading && $index < searchContainer.breadcrumbs.length - 1) {
        <div class="search-hierarchic-bread-crumbs__items">
          <button
            mat-button
            [routerLink]="breadcrumb.$$refData?.routerLink"
            [queryParams]="breadcrumb.$$refData?.queryParams"
            [title]="breadcrumb.artifact_name" class="parent-folder"
            [ngClass]="{'hide-items': showMoreButton && ($index !== 0 && $index !== searchContainer.breadcrumbs.length - 2) }"
          >
            <mat-icon class="folder-icon">
              arrow_back
            </mat-icon>

            {{breadcrumb.artifact_name}}
          </button>

          @if (showMoreButton && $index === 1) {
            <button
              (click)="showAllItems()"
              mat-button
            >
              ...
            </button>
          }
        </div>
      }

      @if (finishedLoading && $index === searchContainer.breadcrumbs.length - 1 && $index === 0) {
        <button
          mat-button
          (click)="goToMenuPath()"
          class="search-hierarchic-bread-crumbs__back-to-folders"
        >
          <mat-icon>
            arrow_back
          </mat-icon>

          <span>
            {{'TRANS__SEARCH_HIERARCHIC_BREAD_CRUMBS__BACK_TO_FOLDERS' | translate}}
          </span>
        </button>
      }
    </ng-container>
  }

  @if (searchContainer.currentPathView.search_view.search_view_type === 'media_folder' && targetId) {
    <button
      mat-button
      (click)="goToMenuPath()"
      class="search-hierarchic-bread-crumbs__back-to-folders"
    >
      <mat-icon>
        arrow_back
      </mat-icon>

      <span>
        {{'TRANS__SEARCH_HIERARCHIC_BREAD_CRUMBS__BACK_TO_FOLDERS' | translate}}
      </span>
    </button>
  }
</div>
